import { render, staticRenderFns } from "./NotifyUsersComponent.vue?vue&type=template&id=18b26e1c&scoped=true"
import script from "./NotifyUsersComponent.vue?vue&type=script&lang=js"
export * from "./NotifyUsersComponent.vue?vue&type=script&lang=js"
import style0 from "./NotifyUsersComponent.vue?vue&type=style&index=0&id=18b26e1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b26e1c",
  null
  
)

export default component.exports